export const API_KEY = "AIzaSyCAiH6FRJq8vT2oQ_lT4Vzw5tLc3IllexI";

export default API_KEY;